import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PplDialogRef } from '@ppl/ui/dialog';
import { createDialogSuccessResponse, type DialogResponse } from '@ppl/utils/dialog.utils';


@Component({
  selector: 'ppl-sign-in-completed-dialog',
  standalone: false,
  templateUrl: './sign-in-completed-dialog.component.html',
  styleUrl: './sign-in-completed-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SignInCompletedDialogComponent {
  constructor(
    private dialogRef: PplDialogRef<SignInCompletedDialogComponent, DialogResponse>
  ) { }

  onAction() {
    this.dialogRef.close(createDialogSuccessResponse());
  }
}
